import React, { useState } from "react";

interface IFaqQuetionComponentProps {
    question: string;
    answer: string;
    activeId: string;
    id: string;
    setActiveId: React.Dispatch<React.SetStateAction<string>>;
}

export const FaqQuetionComponent: React.FC<IFaqQuetionComponentProps> = (
    props: IFaqQuetionComponentProps
) => {
    const { activeId, answer, question, id, setActiveId } = props;

    const isOpen = activeId === id;

    const toggleOpen = () => {
        setActiveId(isOpen ? "" : id);
    };

    return (
        <div
            className={`faq-item ${isOpen ? "faq-active" : ""}`}
            onClick={toggleOpen}
        >
            <i className="faq-icon bi bi-question-circle"></i>
            <h3>{question}</h3>
            {isOpen && (
                <div className="faq-content">
                    <p>{answer}</p>
                </div>
            )}
            <i
                className={`faq-toggle bi bi-chevron-right ${
                    isOpen ? "open" : ""
                }`}
            ></i>
        </div>
    );
};
